// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"cd0e014d","257":"17ca3459","321":"f2203968","557":"a0ef5c98","572":"c5080f33","615":"a35c4a65","659":"28de7729","751":"ed77afc1","936":"513c0213","963":"fadece36","974":"b765f9b6"}[chunkId] + ".chunk.js";
};